export function handleFixLockedColumn(grid, props) {
	return (e) => {
		if (props.fixLockedColumn) {
			grid.wrapper.find('.k-grid-content-locked').css('height', '');
		}
	};
}
